(function (pmw, undefined) {

	/**
	 * Native replacement for jQuery.isEmptyObject: true for null/undefined
	 * and for objects without own enumerable keys.
	 *
	 * @param {object|null|undefined} obj
	 * @returns {boolean}
	 */
	pmw.isEmptyObject = obj => {
		if (!obj) return true
		return Object.keys(obj).length === 0
	}

	/**
	 * Run a callback once the DOM is ready. Native replacement for the
	 * jQuery(fn) ready shorthand: runs immediately when the document has
	 * already finished parsing.
	 *
	 * @param {Function} callback
	 * @returns {void}
	 */
	pmw.onDocumentReady = callback => {
		if (document.readyState !== "loading") {
			callback()
			return
		}
		document.addEventListener("DOMContentLoaded", callback)
	}

	pmw.waitForLibrary = (library, timeout = 5000, interval = 100) => {

		const startTime = Date.now()
		while (typeof window[library] === "undefined") {
			// Check if timeout in milliseconds has passed
			if (Date.now() - startTime > timeout) {
				break // Maximum wait time reached, exit the loop
			}
			// Wait for the interval in milliseconds before checking again
			setTimeout(() => {
			}, interval)
		}
	}

	pmw.dataLayerFullyLoaded = async () => {

		// Promise that checks if the nested object pmwDataLayer.version is defined.
		// If so, resolve.
		// We must check for the nested object pmwDataLayer.version,
		// because the pmwDataLayer object can be defined early by adding products to the data layer through
		// template inline scripts. So we need to wait until the pmwDataLayer configuration objects
		// are defined.
		let checkVar = new Promise((resolve) => {
			(function waitForVar() {
				if (
					typeof pmwDataLayer !== "undefined"
					&& typeof pmwDataLayer.version !== "undefined"
				) {
					return resolve()
				}
				setTimeout(waitForVar, 100)
			})()
		})

		// Set a timeout to log a message after 6 seconds
		let logTimeoutId = setTimeout(() => {
			console.error("Pixel Manager error: The pmwDataLayer is not defined. Please make sure that the pmwDataLayer script snippet is inserted and not modified by any third-party plugin, such as a consent management platform or a JavaScript optimizer.")

		}, 6000)

		checkVar.then(() => {
			clearTimeout(logTimeoutId)
		})

		return checkVar
	}

}(window.pmw = window.pmw || {}))
